// extracted by mini-css-extract-plugin
export default {"root":"ProductKindHeader-root_KlSv7","blocks":"ProductKindHeader-blocks__QJE0"};